import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

import { i18n } from "../../main";

Vue.prototype.$relatorios_analiticos = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      relatorio_geral: [],
      relatorio_geral_totais: [],
      relatorio_validacao: [],
      relatorio_validacao_totais: [],
      loading_button_geral: false,
      loading_button_omni: false,
      loading_relatorio_geral: false,
      loading_button_validacao: false,
      loading_relatorio_validacao: false,
      loading_button_export_pdf: false,
      loading_button_export_csv: false,
      relatorio_table: "",
      relatorio_table_totais: "",
      relatorio_financeiro: [],
      relatorio_financeiro_totais: [],
      loading_button_financeiro: false,
      loading_relatorio_financeiro: false,
      loading_relatorio_financeiro_omni: false,
      loading_relatorio_consumidores_omni: false,
      loading_tipo_pessoa: false,
      consumidores: [],
      filtros: [],
      lojas: [],
      lojas_loading: false,
      loading: false,
      filterGeral: {
        loja: null,
        produto: null,
        regional: null,
        agente: "",
        ponto_de_venda: "",
        canal_de_venda: "",
        forma_de_pagamento: "",
        intervalo_datas: null,
        range_dates: [],
        hora_inicial: "",
        hora_final: "",
        error: {
          loja: [],
          range_dates: [],
        },
      },
      filterOmni: {
        loja: null,
        produto: null,
        regional: null,
        agente: "",
        ponto_de_venda: "",
        canal_de_venda: "",
        forma_de_pagamento: "",
        initDateTime: "",
        endDateTime: "",
        estado: "",
        cidade: "",
        error: {
          loja: [],
          initDate: "",
          endDate: "",
        },
      },
      filterValidacao: {
        loja: null,
        produto: null,
        consumidor: null,
        intervalo_datas: null,
        range_dates: [],
        error: {
          range_dates: [],
          loja: [],
        },
      },
      filterFinanceiro: {
        tipo_pessoa: "LOJA",
        loja: null,
        produto: null,
        regional: null,
        agente: "",
        pontos_de_venda: "",
        canal_de_venda: "",
        forma_de_pagamento: "",
        intervalo_datas: null,
        intervalo_datas_lib: null,
        range_dates: [],
        range_dates_lib: [],
        hora_inicial: "",
        hora_final: "",
        produtos: [],
        error: {
          range_dates: [],
          loja: [],
        },
      },
      filterFinanceiroOmni: {
        tipo_pessoa: "LOJA",
        loja: null,
        produto: null,
        regional: null,
        estado: "",
        cidade: "",
        agente: "",
        pontos_de_venda: "",
        canal_de_venda: "",
        forma_de_pagamento: "",

        initDateTimeOrders: "",
        endDateTimeOrders: "",
        initDateTimeRelease: "",
        endDateTimeRelease: "",

        error: {
          initDateTimeOrders: "",
          endDateTimeOrders: "",
          initDateTimeRelease: "",
          endDateTimeRelease: "",
          loja: [],
        },
      },
      filterConsumidoresOmni: {
        nomeConsumidor: "",
        estado: "",
        cidade: "",
        promocoes: null,

        initDateTimeBirth: "",
        endDateTimeBirth: "",
        initDateTimeCreation: "",
        endDateTimeCreation: "",

        error: {
          initDateTimeBirth: "",
          endDateTimeBirth: "",
          initDateTimeCreation: "",
          endDateTimeCreation: "",
          loja: [],
        },
      },
      tipo_pessoa: [{ text: "Loja", value: "LOJA" }],
      intervalo_data: [
        { text: "Dia", value: "date" },
        { text: "Semana", value: "week" },
        { text: "Mês", value: "month" },
        { text: "Personalizado", value: "custom" },
      ],
      intervalo_datas_lib: [
        { text: "Dia", value: "date" },
        { text: "Semana", value: "week" },
        { text: "Mês", value: "month" },
        { text: "Personalizado", value: "custom" },
      ],
      regional: ["GRAMADO", "BENTO GONÇALVES"],
      segmento: ["TESTE1", "TESTE2", "TESTE3"],
      agente: ["AGENTE 1", "AGENTE 2", "AGENTE 3"],
      canais_de_venda: [],
      formas_de_pagamento: [],
    };
  },
  computed: {
    promocoes() {
      return [
        { text: i18n.t("reports.yes"), value: "1" },
        { text: i18n.t("reports.no"), value: "0" },
      ];
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
    getLojaID() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return this.filterValidacao.loja;
      return this.$axios.getLocal("oe_user_info").data.loja;
    },
  },
  methods: {
    // FUNÇOES DE GET RELATÓRIOS
    getVendasPorTipoDeProduto(dados) {
      this.loading = true;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_VENDA_POR_TIPO_PRODUTO,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            this.relatorio_geral = response;
            this.relatorio_validacao = response;
            this.loading = false;
          }
        });
    },

    // FUNÇÕES AUXILIARES
    getCanaisDeVenda() {
      this.loading = true;
      this.$axios
        .get(this.ENDPOINTS.CANAIS_DE_VENDA + "/array")
        .then(response => {
          if (response) {
            this.$axios.setLocal("canais_venda", response);
            this.canais_de_venda = response;
            this.loading = false;
          }
        });
    },

    getFormasDePagamento() {
      this.loading = true;
      this.$axios
        .get(this.ENDPOINTS.FORMAS_DE_PAGAMENTO + "array")
        .then(response => {
          if (response) {
            const modifiedResponse = response.map(item => {
              if (item.key === "QRCODE" && item.value === "QRCODE") {
                return { key: "PIX", value: "QRCODE" };
              }
              return item;
            });
            this.$axios.setLocal("form_pagamentos", modifiedResponse);
            this.formas_de_pagamento = modifiedResponse;
            this.loading = false;
          }
        });
    },

    getAllLojas(dados) {
      this.lojas_loading = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_LOJAS, JSON.stringify(dados))
        .then(response => {
          if (response) {
            this.lojas = response;
            this.lojas_loading = false;
          }
        });
    },

    getLojasByRegional(idregional, dados) {
      this.lojas_loading = true;
      this.$axios
        .get(
          this.ENDPOINTS.LISTAR_LOJAS_REGIONAL + idregional,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            this.lojas = response;
            this.lojas_loading = false;
          }
        });
    },

    clearfilterGeralFields(field) {
      switch (field) {
        case "loja":
          this.filterGeral.loja = "";
          this.$produtos_gerenciar.produtos = [];
          break;
        case "produto":
          this.filterGeral.produto = "";
          break;
        case "regional":
          this.filterGeral.regional = "";
          break;
        // case 'agente':
        //     this.filterGeral.agente = ''
        //     break;
        case "ponto_de_venda":
          this.filterGeral.ponto_de_venda = "";
          break;
        case "cana_de_venda":
          this.filterGeral.canal_de_venda = "";
          break;
        case "forma_de_pagamento":
          this.filterGeral.forma_de_pagamento = "";
          break;
        case "dates":
          this.filterGeral.range_dates = [];
          break;
        case "intervalo_datas":
          this.filterGeral.intervalo_datas = "";
          this.filterGeral.range_dates = [];
          this.filterGeral.hora_inicial = "";
          this.filterGeral.hora_final = "";
          break;
        default:
          break;
      }
    },

    clearfilterOmniFields(field) {
      switch (field) {
        case "loja":
          this.filterOmni.loja = "";
          this.$produtos_gerenciar.produtos = [];
          break;
        case "produto":
          this.filterOmni.produto = "";
          break;
        case "regional":
          this.filterOmni.regional = "";
          break;
        case "estado":
          this.filterOmni.estado = "";
          break;
        case "cidade":
          this.filterOmni.cidade = "";
          break;
        case "ponto_de_venda":
          this.filterOmni.ponto_de_venda = "";
          break;
        case "cana_de_venda":
          this.filterOmni.canal_de_venda = "";
          break;
        case "forma_de_pagamento":
          this.filterOmni.forma_de_pagamento = "";
          break;
        default:
          break;
      }
    },

    clearfilterValidacaoFields(field) {
      switch (field) {
        case "loja":
          this.filterValidacao.loja = "";
          this.$produtos_gerenciar.produtos = [];
          break;
        case "produto":
          this.filterValidacao.produto = "";
          break;
        case "consumidor":
          this.filterValidacao.consumidor = "";
          break;
        case "dates_validacao":
          this.filterValidacao.range_dates = "";
          break;
        default:
          break;
      }
    },

    // FILTRO
    filtroAnaliticoGeral() {
      this.loading_button_geral = true;
      this.loading_relatorio_geral = true;
      this.filtros = [];
      let dados = {};

      // ---- RETORNA ERRO AO NÃO PREENCHER DUAS DATAS ---- //
      if (
        !this.filterGeral.range_dates.length == 0 &&
        this.filterGeral.range_dates.length < 2
      ) {
        this.loading_button_geral = false;
        this.loading_relatorio_geral = false;
        this.$config.alert(
          "Preencha adequadamente os campos!",
          this.$config.dados.errorColor
        );
        this.filterGeral.error.range_dates =
          "Preencha adequadamente os campos!";
        return;
      }
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin") {
        if (this.filterGeral.loja == "" || this.filterGeral.loja == null) {
          this.loading_button_geral = false;
          this.loading_relatorio_geral = false;

          if (this.filterGeral.loja != 0 || this.filterGeral.loja == null) {
            if (
              (this.filterGeral.loja == "" && this.getEnviroment()) ||
              this.filterGeral.loja == null
            ) {
              this.loading_button = false;
              this.loading_venda_tipo_produto = false;
              this.$config.alert(
                "Selecione uma loja!",
                this.$config.dados.errorColor
              );
              this.filterGeral.error.loja = "Selecione uma loja!";
              return;
            }
          }
        }
      }

      if (
        this.filterGeral.regional !== "" &&
        this.filterGeral.regional !== null
      ) {
        dados.idregional = this.filterGeral.regional;
      }

      if (this.filterGeral.loja !== "" && this.filterGeral.loja !== null) {
        dados.loja = this.filterGeral.loja;
      }

      if (
        this.filterGeral.produto !== "" &&
        this.filterGeral.produto !== null
      ) {
        dados.dsc_produto = this.filterGeral.produto;
      }

      if (
        this.filterGeral.canal_de_venda !== "" &&
        this.filterGeral.canal_de_venda !== null
      ) {
        dados.canal_venda = this.filterGeral.canal_de_venda;
      }

      if (
        this.filterGeral.forma_de_pagamento !== "" &&
        this.filterGeral.forma_de_pagamento !== null
      ) {
        dados.forma_pagamento = this.filterGeral.forma_de_pagamento;
      }

      if (this.filterGeral.range_dates.length > 0) {
        if (this.filterGeral.range_dates.length > 0) {
          dados.dthr_ped_ini =
            this.filterGeral.range_dates[0] +
            " " +
            this.filterGeral.hora_inicial;
          dados.dthr_ped_fim =
            this.filterGeral.range_dates[1] + " " + this.filterGeral.hora_final;
        }
      }
      this.$axios
        .post(this.ENDPOINTS.RELATORIO_ANALITICO_GERAL, JSON.stringify(dados))
        .then(response => {
          if (response) {
            const arrayOfObj = Object.entries(response.INFO).map(e => e[1]);
            this.relatorio_geral = arrayOfObj;
            this.relatorio_geral_totais =
              response.TOTAIS.length === 0 ? [] : [response.TOTAIS];
            this.loading_button_geral = false;
            this.loading_relatorio_geral = false;
            this.filtros = [];
          }
        })
        .catch(() => {
          this.loading_button_geral = false;
          this.loading_relatorio_geral = false;
        })
        .finally(() => {
          this.loading_button_geral = false;
          this.loading_relatorio_geral = false;
        });
    },

    // FILTRO
    filtroAnaliticoOmni() {
      this.loading_button_omni = true;
      this.filtros = [];
      let dados = {};
      if (
        this.filterOmni.initDateTime == "" ||
        this.filterOmni.initDateTime == null
      ) {
        this.loading_button_omni = false;
        this.$config.alert(
          "O campo de data inicial não pode ser vazio!",
          this.$config.dados.errorColor
        );
        this.filterOmni.error.initDateTime =
          "O campo de data inicial não pode ser vazio!";
        return;
      } else {
        dados.dthr_ped_ini = this.filterOmni.initDateTime;
      }
      if (
        this.filterOmni.endDateTime == "" ||
        this.filterOmni.endDateTime == null
      ) {
        this.loading_button_omni = false;
        this.$config.alert(
          "O campo de data final não pode ser vazio!",
          this.$config.dados.errorColor
        );
        this.filterOmni.error.endDateTime =
          "O campo de data final não pode ser vazio!";
        return;
      } else {
        dados.dthr_ped_fim = this.filterOmni.endDateTime;
      }
      if (
        this.filterOmni.regional !== "" &&
        this.filterOmni.regional !== null
      ) {
        dados.idregional = this.filterOmni.regional;
      }

      if (this.filterOmni.estado !== "" && this.filterOmni.estado !== null) {
        dados.estado = this.filterOmni.estado;
      }

      if (this.filterOmni.cidade !== "" && this.filterOmni.cidade !== null) {
        dados.cidade = this.filterOmni.cidade;
      }

      if (this.filterOmni.loja !== "" && this.filterOmni.loja !== null) {
        dados.loja = this.filterOmni.loja;
      }

      if (this.filterOmni.produto !== "" && this.filterOmni.produto !== null) {
        dados.dsc_produto = this.filterOmni.produto;
      }

      if (
        this.filterOmni.canal_de_venda !== "" &&
        this.filterOmni.canal_de_venda !== null
      ) {
        dados.canal_venda = this.filterOmni.canal_de_venda;
      }

      if (
        this.filterOmni.forma_de_pagamento !== "" &&
        this.filterOmni.forma_de_pagamento !== null
      ) {
        dados.forma_pagamento = this.filterOmni.forma_de_pagamento;
      }

      this.$axios
        .post(
          this.ENDPOINTS.RELATORIO_ANALITICO_OMNICHANNEL,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            this.filtros = [];
            this.loading_button_omni = true;
          }
        })
        .catch(error => {
          throw new Error(error);
        })
        .finally(() => {
          this.loading_button_omni = false;
        });
    },

    // FILTRO
    filtroAnaliticoValidacao() {
      this.loading_button_validacao = true;
      this.loading_relatorio_validacao = true;
      this.filtros = [];
      let dados = {};
      dados.loja = this.getLojaID;

      // ---- RETORNA ERRO AO NÃO PREENCHER DUAS DATAS ---- //
      if (
        !this.filterValidacao.range_dates.length == 0 &&
        this.filterValidacao.range_dates.length < 2
      ) {
        this.loading_button_validacao = false;
        this.loading_relatorio_validacao = false;
        this.$config.alert(
          "Preencha adequadamente os campos!",
          this.$config.dados.errorColor
        );
        this.filterValidacao.error.range_dates =
          "Preencha adequadamente os campos!";
        return;
      }

      if (this.isAdmin && this.filterValidacao.loja != 0) {
        if (
          this.filterValidacao.loja == "" ||
          this.filterValidacao.loja == null
        ) {
          this.loading_button_validacao = false;
          this.loading_relatorio_validacao = false;
          this.$config.alert(
            "Selecione uma loja!",
            this.$config.dados.errorColor
          );
          this.filterValidacao.error.loja = "Selecione uma loja!";
          return;
        }
      }

      if (
        this.filterValidacao.loja !== "" &&
        this.filterValidacao.loja !== null
      ) {
        dados.loja = this.filterValidacao.loja;
      }

      if (
        this.filterValidacao.produto !== "" &&
        this.filterValidacao.produto !== null
      ) {
        dados.dsc_produto = this.filterValidacao.produto;
      }

      if (
        this.filterValidacao.consumidor !== "" &&
        this.filterValidacao.consumidor !== null
      ) {
        dados.idconsumidor = this.filterValidacao.consumidor;
      }

      if (this.filterValidacao.range_dates.length > 0) {
        if (this.filterValidacao.range_dates.length > 0) {
          dados.dthr_ini = this.filterValidacao.range_dates[0] + " 00:00";
          dados.dthr_fim = this.filterValidacao.range_dates[1] + " 23:59";
        }
      }
      this.$axios
        .post(
          this.ENDPOINTS.RELATORIO_ANALITICO_VALIDACAO,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            this.relatorio_validacao = response.itens;
            this.relatorio_validacao_totais =
              response.totais.length === 0 ? [] : [response.totais];
            this.loading_button_validacao = false;
            this.loading_relatorio_validacao = false;
            this.filtros = [];
          }
        })
        .catch(() => {
          this.loading_button_validacao = false;
          this.loading_relatorio_validacao = false;
        })
        .finally(() => {
          this.loading_button_validacao = false;
          this.loading_relatorio_validacao = false;
        });
    },

    filtroAnaliticoFinanceiro(table) {
      this.relatorio_table = table;
      this.relatorio_table_totais = table;
      let filtros = {};
      this.loading_button_financeiro = true;
      this.loading_relatorio_financeiro = true;

      // ---- RETORNA ERRO AO NÃO PREENCHER DUAS DATAS ---- //
      if (
        !this.filterFinanceiro.range_dates.length == 0 &&
        this.filterFinanceiro.range_dates.length < 2
      ) {
        this.loading_button_financeiro = false;
        this.loading_relatorio_financeiro = false;
        this.$config.alert(
          "Preencha adequadamente os campos!",
          this.$config.dados.errorColor
        );
        this.filterFinanceiro.error.range_dates =
          "Preencha adequadamente os campos!";
        return;
      }
      if (
        this.filterFinanceiro.loja == null &&
        this.filterFinanceiro.tipo_pessoa === "LOJA" &&
        this.isAdmin
      ) {
        this.loading_button_financeiro = false;
        this.loading_relatorio_financeiro = false;
        this.$config.alert(
          "Selecione uma loja!",
          this.$config.dados.errorColor
        );
        this.filterFinanceiro.error.loja = "Selecione uma loja!";
        return;
      }

      if (
        this.filterFinanceiro.tipo_pessoa !== "" &&
        this.filterFinanceiro.tipo_pessoa !== null
      ) {
        filtros.tipo_pessoa = this.filterFinanceiro.tipo_pessoa
          ? this.filterFinanceiro.tipo_pessoa
          : "LOJA";
      }

      if (
        this.filterFinanceiro.regional !== "" &&
        this.filterFinanceiro.regional !== null
      ) {
        filtros.idregional = this.filterFinanceiro.regional;
      }

      if (
        this.filterFinanceiro.loja !== "" &&
        this.filterFinanceiro.loja !== null
      ) {
        filtros.loja = this.filterFinanceiro.loja;
      }

      if (this.filterFinanceiro.produtos.length > 0) {
        filtros.produtos = this.filterFinanceiro.produtos;
      }

      if (
        this.filterFinanceiro.pontos_de_venda !== "" &&
        this.filterFinanceiro.pontos_de_venda !== null
      ) {
        filtros.idponto_venda = this.filterFinanceiro.pontos_de_venda;
      }

      if (
        this.filterFinanceiro.canal_de_venda !== "" &&
        this.filterFinanceiro.canal_de_venda !== null
      ) {
        filtros.canal_venda = this.filterFinanceiro.canal_de_venda;
      }

      if (
        this.filterFinanceiro.forma_de_pagamento !== "" &&
        this.filterFinanceiro.forma_de_pagamento !== null
      ) {
        filtros.metodo_pag = this.filterFinanceiro.forma_de_pagamento;
      }

      if (this.filterFinanceiro.range_dates.length > 0) {
        filtros.dthr_ini = this.filterFinanceiro.range_dates[0] + " 00:00";
        filtros.dthr_fim = this.filterFinanceiro.range_dates[1] + " 23:59";
      }

      if (this.filterFinanceiro.range_dates_lib.length > 0) {
        filtros.dthr_ini_lib =
          this.filterFinanceiro.range_dates_lib[0] + " 00:00";
        filtros.dthr_fim_lib =
          this.filterFinanceiro.range_dates_lib[1] + " 23:59";
      }
      this.$axios
        .post(this.ENDPOINTS.RELATORIO_ANALITICO_FINANCEIRO, filtros)
        .then(response => {
          const arrayOfObj = Object.entries(response.info).map(e => e[1]);
          this.relatorio_financeiro = arrayOfObj;
          this.relatorio_financeiro_totais =
            response.totais.length === 0 ? [] : [response.totais];
          this.loading_button_financeiro = false;
          this.loading_relatorio_financeiro = false;
        })
        .catch(() => {
          this.loading_button_financeiro = false;
          this.loading_relatorio_financeiro = false;
        })
        .finally(() => {
          this.loading_button_financeiro = false;
          this.loading_relatorio_financeiro = false;
        });
    },

    filtroAnaliticoFinanceiroOmni() {
      this.loading_relatorio_financeiro_omni = true;
      let filtros = {};
      if (
        (this.filterFinanceiroOmni.initDateTimeOrders == "" ||
          this.filterFinanceiroOmni.endDateTimeOrders == "") &&
        (this.filterFinanceiroOmni.initDateTimeRelease == "" ||
          this.filterFinanceiroOmni.endDateTimeRelease == "")
      ) {
        this.loading_relatorio_financeiro_omni = false;
        this.$config.alert(
          "Você deve preencher pelo menos um intervalo de datas para gerar o relatório.",
          this.$config.dados.errorColor
        );
        this.filterFinanceiroOmni.error.initDateTimeOrders =
          "Campo obrigatório";
        this.filterFinanceiroOmni.error.initDateTimeRelease =
          "Campo obrigatório";

        return;
      }

      if (
        this.filterFinanceiroOmni.tipo_pessoa !== "" &&
        this.filterFinanceiroOmni.tipo_pessoa !== null
      ) {
        filtros.tipo_pessoa = this.filterFinanceiroOmni.tipo_pessoa || "LOJA";
      }

      if (
        this.filterFinanceiroOmni.regional !== "" &&
        this.filterFinanceiroOmni.regional !== null
      ) {
        filtros.idregional = this.filterFinanceiroOmni.regional;
      }

      if (
        this.filterFinanceiroOmni.estado !== "" &&
        this.filterFinanceiroOmni.estado !== null
      ) {
        filtros.estado = this.filterFinanceiroOmni.estado;
      }

      if (
        this.filterFinanceiroOmni.cidade !== "" &&
        this.filterFinanceiroOmni.cidade !== null
      ) {
        filtros.cidade = this.filterFinanceiroOmni.cidade;
      }

      if (
        this.filterFinanceiroOmni.loja !== "" &&
        this.filterFinanceiroOmni.loja !== null
      ) {
        filtros.loja = this.filterFinanceiroOmni.loja;
      }

      if (
        this.filterFinanceiroOmni.canal_de_venda !== "" &&
        this.filterFinanceiroOmni.canal_de_venda !== null
      ) {
        filtros.canal_venda = this.filterFinanceiroOmni.canal_de_venda;
      }

      if (this.filterFinanceiroOmni.initDateTimeOrders) {
        filtros.dthr_ini = this.filterFinanceiroOmni.initDateTimeOrders;
      }
      if (this.filterFinanceiroOmni.endDateTimeOrders) {
        filtros.dthr_fim = this.filterFinanceiroOmni.endDateTimeOrders;
      }
      if (this.filterFinanceiroOmni.initDateTimeRelease) {
        filtros.dthr_ini_lib = this.filterFinanceiroOmni.initDateTimeRelease;
      }
      if (this.filterFinanceiroOmni.endDateTimeRelease) {
        filtros.dthr_fim_lib = this.filterFinanceiroOmni.endDateTimeRelease;
      }

      const msg = this.$config.alert(
        "O relatório solicitado está sendo gerado. Aguarde alguns instantes, que você receberá o arquivo no seu e-mail de usuário Eleven.",
        this.$config.dados.successColor
      );
      this.$axios
        .postPDF(
          this.ENDPOINTS.RELATORIO_ANALITICO_FINANCEIRO_OMNI,
          JSON.stringify(filtros)
        )
        .then(response => {
          if (response) {
            this.loading_relatorio_financeiro_omni = true;
            msg;
          }
        })
        .catch(error => {
          throw new Error(error);
        })
        .finally(() => {
          this.loading_relatorio_financeiro_omni = false;
        });
    },

    filtroConsumidoresOmni() {
      this.loading_relatorio_consumidores_omni = true;
      let filtros = {};

      if (
        this.filterConsumidoresOmni.nomeConsumidor !== "" &&
        this.filterConsumidoresOmni.nomeConsumidor !== null
      ) {
        filtros.nome = this.filterConsumidoresOmni.nomeConsumidor;
      }

      if (
        this.filterConsumidoresOmni.estado !== "" &&
        this.filterConsumidoresOmni.estado !== null
      ) {
        filtros.estado = this.filterConsumidoresOmni.estado;
      }

      if (
        this.filterConsumidoresOmni.cidade !== "" &&
        this.filterConsumidoresOmni.cidade !== null
      ) {
        filtros.cidade = this.filterConsumidoresOmni.cidade;
      }

      if (
        this.filterConsumidoresOmni.promocoes !== "" &&
        this.filterConsumidoresOmni.promocoes !== null
      ) {
        filtros.newsletter = this.filterConsumidoresOmni.promocoes;
      }

      if (this.filterConsumidoresOmni.initDateTimeBirth) {
        filtros.data_ini = this.filterConsumidoresOmni.initDateTimeBirth;
      }
      if (this.filterConsumidoresOmni.endDateTimeBirth) {
        filtros.data_fim = this.filterConsumidoresOmni.endDateTimeBirth;
      }
      if (this.filterConsumidoresOmni.initDateTimeCreation) {
        filtros.data_ini_cadastro =
          this.filterConsumidoresOmni.initDateTimeCreation;
      }
      if (this.filterConsumidoresOmni.endDateTimeCreation) {
        filtros.data_fim_cadastro =
          this.filterConsumidoresOmni.endDateTimeCreation;
      }

      const msg = this.$config.alert(
        "O relatório solicitado está sendo gerado. Aguarde alguns instantes, que você receberá o arquivo no seu e-mail de usuário Eleven.",
        this.$config.dados.successColor
      );
      this.$axios
        .postPDF(
          this.ENDPOINTS.RELATORIO_ANALITICO_CONSUMIDORES_OMNI,
          JSON.stringify(filtros)
        )
        .then(response => {
          if (response) {
            this.loading_relatorio_consumidores_omni = true;
            msg;
          }
        })
        .catch(error => {
          throw new Error(error);
        })
        .finally(() => {
          this.loading_relatorio_consumidores_omni = false;
        });
    },

    imprimirPDF() {
      this.loading_button_export_pdf = true;
      let filtros = { exportation: "PDF" };
      if (
        this.filterFinanceiro.tipo_pessoa !== "" &&
        this.filterFinanceiro.tipo_pessoa !== null
      ) {
        filtros.tipo_pessoa = this.filterFinanceiro.tipo_pessoa || "LOJA";
      }

      if (
        this.filterFinanceiro.regional !== "" &&
        this.filterFinanceiro.regional !== null
      ) {
        filtros.idregional = this.filterFinanceiro.regional;
      }

      if (
        this.filterFinanceiro.loja !== "" &&
        this.filterFinanceiro.loja !== null
      ) {
        filtros.loja = this.filterFinanceiro.loja;
      }

      if (this.filterFinanceiro.produtos.length > 0) {
        filtros.produtos = this.filterFinanceiro.produtos;
      }

      if (
        this.filterFinanceiro.canal_de_venda !== "" &&
        this.filterFinanceiro.canal_de_venda !== null
      ) {
        filtros.canal_venda = this.filterFinanceiro.canal_de_venda;
      }

      if (
        this.filterFinanceiro.forma_de_pagamento !== "" &&
        this.filterFinanceiro.forma_de_pagamento !== null
      ) {
        filtros.metodo_pag = this.filterFinanceiro.forma_de_pagamento;
      }

      if (this.filterFinanceiro.range_dates.length > 0) {
        filtros.dthr_ini = this.filterFinanceiro.range_dates[0] + " 00:00";
        filtros.dthr_fim = this.filterFinanceiro.range_dates[1] + " 23:59";
      }
      this.$axios
        .postPDF(
          this.ENDPOINTS.RELATORIO_ANALITICO_FINANCEIRO,
          JSON.stringify(filtros)
        )
        .then(response => {
          if (response) {
            var file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.loading_button_export_pdf = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    imprimirExcel() {
      this.loading_button_export_csv = true;
      let filtros = { exportation: "CSV" };
      if (
        this.filterFinanceiro.tipo_pessoa !== "" &&
        this.filterFinanceiro.tipo_pessoa !== null
      ) {
        filtros.tipo_pessoa = this.filterFinanceiro.tipo_pessoa || "LOJA";
      }

      if (
        this.filterFinanceiro.regional !== "" &&
        this.filterFinanceiro.regional !== null
      ) {
        filtros.idregional = this.filterFinanceiro.regional;
      }

      if (
        this.filterFinanceiro.loja !== "" &&
        this.filterFinanceiro.loja !== null
      ) {
        filtros.loja = this.filterFinanceiro.loja;
      }

      if (this.filterFinanceiro.produtos.length > 0) {
        filtros.produtos = this.filterFinanceiro.produtos;
      }

      if (
        this.filterFinanceiro.canal_de_venda !== "" &&
        this.filterFinanceiro.canal_de_venda !== null
      ) {
        filtros.canal_venda = this.filterFinanceiro.canal_de_venda;
      }

      if (
        this.filterFinanceiro.forma_de_pagamento !== "" &&
        this.filterFinanceiro.forma_de_pagamento !== null
      ) {
        filtros.metodo_pag = this.filterFinanceiro.forma_de_pagamento;
      }

      if (this.filterFinanceiro.range_dates.length > 0) {
        filtros.dthr_ini = this.filterFinanceiro.range_dates[0] + " 00:00";
        filtros.dthr_fim = this.filterFinanceiro.range_dates[1] + " 23:59";
      }
      this.$axios
        .postPDF(
          this.ENDPOINTS.RELATORIO_ANALITICO_FINANCEIRO,
          JSON.stringify(filtros)
        )
        .then(response => {
          if (response) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            var file = new Blob([response], { type: "text/csv" });
            var fileURL = URL.createObjectURL(file);
            a.href = fileURL;
            a.download = "Relatório Financeiro";
            a.click();
            window.URL.revokeObjectURL(fileURL);
            this.loading_button_export_csv = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    imprimirPDFGeral() {
      this.loading_button_export_pdf = true;
      let dados = {
        exportation: "PDF",
      };
      if (
        this.filterGeral.regional !== "" &&
        this.filterGeral.regional !== null
      ) {
        dados.idregional = this.filterGeral.regional;
      }

      if (this.filterGeral.loja !== "" && this.filterGeral.loja !== null) {
        dados.loja = this.filterGeral.loja;
      }

      if (
        this.filterGeral.produto !== "" &&
        this.filterGeral.produto !== null
      ) {
        dados.dsc_produto = this.filterGeral.produto;
      }

      if (
        this.filterGeral.canal_de_venda !== "" &&
        this.filterGeral.canal_de_venda !== null
      ) {
        dados.canal_venda = this.filterGeral.canal_de_venda;
      }

      if (
        this.filterGeral.forma_de_pagamento !== "" &&
        this.filterGeral.forma_de_pagamento !== null
      ) {
        dados.forma_pagamento = this.filterGeral.forma_de_pagamento;
      }

      if (this.filterGeral.range_dates.length > 0) {
        if (this.filterGeral.range_dates.length > 0) {
          dados.dthr_ped_ini = this.filterGeral.range_dates[0] + " 00:00";
          dados.dthr_ped_fim = this.filterGeral.range_dates[1] + " 23:59";
        }
      }
      this.$axios
        .postPDF(
          this.ENDPOINTS.RELATORIO_ANALITICO_GERAL,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            var file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.loading_button_export_pdf = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    imprimirCSVGeral() {
      this.loading_button_export_csv = true;
      let dados = {
        exportation: "CSV",
      };
      if (
        this.filterGeral.regional !== "" &&
        this.filterGeral.regional !== null
      ) {
        dados.idregional = this.filterGeral.regional;
      }

      if (this.filterGeral.loja !== "" && this.filterGeral.loja !== null) {
        dados.loja = this.filterGeral.loja;
      }

      if (
        this.filterGeral.produto !== "" &&
        this.filterGeral.produto !== null
      ) {
        dados.dsc_produto = this.filterGeral.produto;
      }

      if (
        this.filterGeral.canal_de_venda !== "" &&
        this.filterGeral.canal_de_venda !== null
      ) {
        dados.canal_venda = this.filterGeral.canal_de_venda;
      }

      if (
        this.filterGeral.forma_de_pagamento !== "" &&
        this.filterGeral.forma_de_pagamento !== null
      ) {
        dados.forma_pagamento = this.filterGeral.forma_de_pagamento;
      }

      if (this.filterGeral.range_dates.length > 0) {
        if (this.filterGeral.range_dates.length > 0) {
          dados.dthr_ped_ini = this.filterGeral.range_dates[0] + " 00:00";
          dados.dthr_ped_fim = this.filterGeral.range_dates[1] + " 23:59";
        }
      }
      this.$axios
        .postPDF(
          this.ENDPOINTS.RELATORIO_ANALITICO_GERAL,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            var file = new Blob([response], { type: "text/csv" });
            var fileURL = URL.createObjectURL(file);
            a.href = fileURL;
            a.download = "Relatório Analítico Geral";
            a.click();
            window.URL.revokeObjectURL(fileURL);
            this.loading_button_export_csv = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    imprimirPDFValidacao() {
      this.loading_button_export_pdf = true;
      let dados = {
        exportation: "PDF",
      };
      if (
        this.filterValidacao.loja !== "" &&
        this.filterValidacao.loja !== null
      ) {
        dados.loja = this.filterValidacao.loja;
      }

      if (
        this.filterValidacao.produto !== "" &&
        this.filterValidacao.produto !== null
      ) {
        dados.dsc_produto = this.filterValidacao.produto;
      }

      if (
        this.filterValidacao.consumidor !== "" &&
        this.filterValidacao.consumidor !== null
      ) {
        dados.idconsumidor = this.filterValidacao.consumidor;
      }

      if (this.filterValidacao.range_dates.length > 0) {
        if (this.filterValidacao.range_dates.length > 0) {
          dados.dthr_ini = this.filterValidacao.range_dates[0] + " 00:00";
          dados.dthr_fim = this.filterValidacao.range_dates[1] + " 23:59";
        }
      }
      this.$axios
        .postPDF(
          this.ENDPOINTS.RELATORIO_ANALITICO_VALIDACAO,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            var file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.loading_button_export_pdf = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    imprimirCSVValidacao() {
      this.loading_button_export_csv = true;
      let dados = {
        exportation: "CSV",
      };
      if (
        this.filterValidacao.loja !== "" &&
        this.filterValidacao.loja !== null
      ) {
        dados.loja = this.filterValidacao.loja;
      }

      if (
        this.filterValidacao.produto !== "" &&
        this.filterValidacao.produto !== null
      ) {
        dados.dsc_produto = this.filterValidacao.produto;
      }

      if (
        this.filterValidacao.consumidor !== "" &&
        this.filterValidacao.consumidor !== null
      ) {
        dados.idconsumidor = this.filterValidacao.consumidor;
      }

      if (this.filterValidacao.range_dates.length > 0) {
        if (this.filterValidacao.range_dates.length > 0) {
          dados.dthr_ini = this.filterValidacao.range_dates[0] + " 00:00";
          dados.dthr_fim = this.filterValidacao.range_dates[1] + " 23:59";
        }
      }
      this.$axios
        .postPDF(
          this.ENDPOINTS.RELATORIO_ANALITICO_VALIDACAO,
          JSON.stringify(dados)
        )
        .then(response => {
          if (response) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            var file = new Blob([response], { type: "text/csv" });
            var fileURL = URL.createObjectURL(file);
            a.href = fileURL;
            a.download = "Relatório Analítico de Validacao";
            a.click();
            window.URL.revokeObjectURL(fileURL);
            this.loading_button_export_csv = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    clearfilterFinanceiroFields(field) {
      switch (field) {
        case "loja":
          this.filterFinanceiro.loja = "";
          this.$produtos_gerenciar.produtos = [];
          break;
        case "produto":
          this.filterFinanceiro.produto = "";
          break;
        case "produtos":
          this.filterFinanceiro.produtos = "";
          break;
        case "regional":
          this.filterFinanceiro.regional = "";
          break;
        // case 'agente':
        //     this.filterGeral.agente = ''
        //     break;
        case "ponto_de_venda":
          this.filterFinanceiro.ponto_de_venda = "";
          break;
        case "cana_de_venda":
          this.filterFinanceiro.canal_de_venda = "";
          break;
        case "forma_de_pagamento":
          this.filterFinanceiro.forma_de_pagamento = "";
          break;
        case "dates":
          this.filterFinanceiro.range_dates = "";
          this.filterFinanceiro.range_dates_lib = "";
          break;
        case "tipo_pessoa":
          this.filterFinanceiro.tipo_pessoa = "";
          break;
        case "intervalo_de_pedidos":
          this.filterFinanceiro.range_dates = "";
          break;
        case "intervalo_de_pedidos_lib":
          this.filterFinanceiro.range_dates_lib = "";
          break;
        default:
          break;
      }
    },

    clearfilterFinanceiroOmniFields(field) {
      switch (field) {
        case "loja":
          this.filterFinanceiroOmni.loja = "";
          this.$produtos_gerenciar.produtos = [];
          break;
        case "produto":
          this.filterFinanceiroOmni.produto = "";
          break;
        case "regional":
          this.filterFinanceiroOmni.regional = "";
          break;
        case "estado":
          this.filterFinanceiroOmni.estado = "";
          break;
        case "cidade":
          this.filterFinanceiroOmni.cidade = "";
          break;
        case "ponto_de_venda":
          this.filterFinanceiroOmni.ponto_de_venda = "";
          break;
        case "cana_de_venda":
          this.filterFinanceiroOmni.canal_de_venda = "";
          break;
        case "forma_de_pagamento":
          this.filterFinanceiroOmni.forma_de_pagamento = "";
          break;
        case "dates":
          this.filterFinanceiroOmni.range_dates = "";
          this.filterFinanceiroOmni.range_dates_lib = "";
          break;
        case "tipo_pessoa":
          this.filterFinanceiroOmni.tipo_pessoa = "";
          break;
        case "intervalo_de_pedidos":
          this.filterFinanceiroOmni.range_dates = "";
          break;
        case "intervalo_de_pedidos_lib":
          this.filterFinanceiroOmni.range_dates_lib = "";
          break;
        default:
          break;
      }
    },

    clearfilterConsumidoresOmniFields(field) {
      switch (field) {
        case "nomeConsumidor":
          this.filterConsumidoresOmni.nomeConsumidor = "";
          break;
        case "estado":
          this.filterConsumidoresOmni.estado = "";
          break;
        case "cidade":
          this.filterConsumidoresOmni.cidade = "";
          break;
        case "dates":
          this.filterConsumidoresOmni.range_dates = "";
          break;
        case "intervalo_data":
          this.filterConsumidoresOmni.intervalo_datas = "";
          break;
        case "promocoes":
          this.filterConsumidoresOmni.promocoes = null;
          break;
        default:
          break;
      }
    },

    limpaFiltros() {
      this.filterGeral.loja = null;
      this.filterGeral.produto = null;
      this.filterGeral.regional = null;
      this.filterGeral.agente = "";
      this.filterGeral.ponto_de_venda = "";
      this.filterGeral.canal_de_venda = "";
      this.filterGeral.forma_de_pagamento = "";
      this.filterGeral.intervalo_datas = null;
      this.filterGeral.range_dates = [];
      this.filterGeral.error.loja = [];
      this.filterGeral.hora_inicial = "";
      this.filterGeral.hora_final = "";
      this.relatorio_geral = [];
      this.relatorio_geral_totais = [];
    },
    limpaFiltrosOmni() {
      this.filterOmni.loja = null;
      this.filterOmni.produto = null;
      this.filterOmni.regional = null;
      this.filterOmni.error.loja = [];
      this.filterOmni.estado = "";
      this.filterOmni.cidade = "";
      this.filterOmni.agente = "";
      this.filterOmni.ponto_de_venda = "";
      this.filterOmni.canal_de_venda = "";
      this.filterOmni.forma_de_pagamento = "";
      this.filterOmni.initDate = "";
      this.filterOmni.endDate = "";
      this.filterOmni.initDateView = "";
      this.filterOmni.endDateView = "";
      this.filterOmni.hora_inicial = "";
      this.filterOmni.hora_final = "";
    },
    limpaFiltrosValidacao() {
      this.filterValidacao.loja = null;
      this.filterValidacao.produto = null;
      this.filterValidacao.regional = null;
      this.filterValidacao.agente = "";
      this.filterValidacao.ponto_de_venda = "";
      this.filterValidacao.canal_de_venda = "";
      this.filterValidacao.forma_de_pagamento = "";
      this.filterValidacao.intervalo_datas = null;
      this.filterValidacao.range_dates = [];
      this.filterValidacao.hora_inicial = "";
      this.filterValidacao.hora_final = "";
      this.relatorio_validacao = [];
      this.relatorio_validacao_totais = [];
    },

    limpaFiltrosFinanceiro() {
      this.filterFinanceiro.loja = null;
      this.filterFinanceiro.produto = null;
      this.filterFinanceiro.produtos = [];
      this.filterFinanceiro.regional = null;
      this.filterFinanceiro.agente = "";
      this.filterFinanceiro.ponto_de_venda = "";
      this.filterFinanceiro.canal_de_venda = "";
      this.filterFinanceiro.forma_de_pagamento = "";
      this.filterFinanceiro.intervalo_datas = null;
      this.filterFinanceiro.intervalo_datas_lib = null;
      this.filterFinanceiro.range_dates = [];
      this.filterFinanceiro.range_dates_lib = [];
      this.filterFinanceiro.hora_inicial = "";
      this.filterFinanceiro.hora_final = "";
      this.relatorio_geral = [];
      this.relatorio_geral_totais = [];
      this.filterFinanceiro.tipo_pessoa = "LOJA";
    },
    limpaFiltrosFinanceiroOmni() {
      this.filterFinanceiroOmni.loja = null;
      this.filterFinanceiroOmni.produto = null;
      this.filterFinanceiroOmni.regional = null;
      this.filterFinanceiroOmni.estado = "";
      this.filterFinanceiroOmni.cidade = "";
      this.filterFinanceiroOmni.agente = "";
      this.filterFinanceiroOmni.ponto_de_venda = "";
      this.filterFinanceiroOmni.canal_de_venda = "";
      this.filterFinanceiroOmni.forma_de_pagamento = "";
      this.filterFinanceiroOmni.initDateOrders = "";
      this.filterFinanceiroOmni.endDateOrders = "";
      this.filterFinanceiroOmni.initDateRelease = "";
      this.filterFinanceiroOmni.endDateRelease = "";
      this.filterFinanceiroOmni.hora_inicial = "";
      this.filterFinanceiroOmni.hora_final = "";
      this.filterFinanceiroOmni.tipo_pessoa = "LOJA";
    },
  },
  limpaFiltrosConsumidoresOmni() {
    this.filterConsumidoresOmni.initDateViewBirth = "";
    this.filterConsumidoresOmni.endDateViewBirth = "";
    this.filterConsumidoresOmni.initDateViewCreation = "";
    this.filterConsumidoresOmni.endDateViewCreation = "";
    this.filterConsumidoresOmni.estado = "";
    this.filterConsumidoresOmni.cidade = "";
    this.filterConsumidoresOmni.nomeConsumidor = "";
    this.filterConsumidoresOmni.promocoes = null;
  },
});
